  const getLinkedInUrl = (links?: string[]) => {
    if (!links || !Array.isArray(links)) return ""
    const linkedInLink = links.find(link => link.toLowerCase().includes('linkedin.com'))
    return linkedInLink || ""
  };

export default getLinkedInUrl;